import { FEATURE_FLAG_KEYS } from 'app/shop-ui/constants';

import {
    LayoutNodeStyle,
    type LayoutNodeStyleMap,
    type LayoutSiteStyleMap,
} from 'shop-ui/types/basic';

export const NodeStyleManager = {
    getNodeStyle(styleMap: LayoutNodeStyleMap, id: string) {
        return styleMap[id] ?? {};
    },

    getNodeStyleByType(
        styleMap: LayoutNodeStyleMap,
        id: string,
        type: FEATURE_FLAG_KEYS
    ): LayoutNodeStyle[keyof LayoutNodeStyle] {
        return styleMap[id]?.[type] ?? null;
    },

    getNodeStyleByFeatureFlag(
        styleMap: LayoutNodeStyleMap,
        featureFlag: keyof LayoutNodeStyleMap[number]
    ) {
        return Object.entries(styleMap).reduce((acc, [id, style]) => {
            if (style[featureFlag]) {
                const result = {
                    [featureFlag]: style[featureFlag],
                };

                acc[id] = result;
            }

            return acc;
        }, {} as LayoutNodeStyleMap);
    },

    getSiteStyle(
        siteStyle: LayoutSiteStyleMap,
        featureFlag: keyof LayoutSiteStyleMap
    ): LayoutSiteStyleMap[keyof LayoutSiteStyleMap] {
        return siteStyle[featureFlag] ?? '';
    },

    setNodeStyle(styleMap: LayoutNodeStyleMap, id: string, style: LayoutNodeStyle) {
        const prevStyle = NodeStyleManager.getNodeStyle(styleMap, id);

        const newStyle = {
            ...prevStyle,
            ...style,
        };

        return newStyle;
    },
};
